import React, { useMemo } from 'react';
import { useCalendarLinkedContextResolved } from '../hooks/useCalendarLinkedContext';
import { SharedCalendarLinkedContext } from './calendarLinkedShared';

export const CalendarLinkedContextProvider: React.FC<{
  workspaceId: string;
  gradeId: string;
  children: React.ReactNode;
}> = ({ workspaceId, gradeId, children }) => {
  const ctx = useCalendarLinkedContextResolved(workspaceId, gradeId, true);
  const value = useMemo(
    () => ({ workspaceId, gradeId, ctx }),
    [workspaceId, gradeId, ctx]
  );
  return (
    <SharedCalendarLinkedContext.Provider value={value}>{children}</SharedCalendarLinkedContext.Provider>
  );
};
